import { ChangeEvent } from "react";
import moment from "moment";

import { Client } from "@/Common/Api/Client";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { Patient } from "@/Common/Models/Patient/Patient";
import * as ServerOperations from "@/Common/Operations/operations.server";

import img_loading from "@/Globals/_images/loading.gif";

interface IDSQPatientComponent {
    onCloseCallback: () => void;
    patientModel: Patient;
}

class DSQPatientComponentState {
    public FirstName: string;
    public LastName: string;
    public NUI: string;
    public NAM: string;
    public SIN: string;
    public Born: Date;
    public Gender: string;

    public MaleChecked: boolean;
    public FemaleChecked: boolean;

    // Server resposnse data
    public CandidateNUI: string;
    public CandidateNam: string;
    public CandidateFirstName: string;
    public CandidateLastName: string;
    public CandidateBirth: string;
    public CandidateGender: string;

    public CandidateStreet: string;
    public CandidateCity: string;
    public CandidateState: string;
    public CandidateZipCode: string;

    public CandidateMotherLastName: string;
    public CandidateMotherFirstName: string;
    public CandidateFatherLastName: string;
    public CandidateFatherFirstName: string;
    public CandidateDeceasedDate: string;
    public showTruncateMessage: boolean;

    public isLoading: boolean;
}

class DSQPatientComponent extends React.Component<IDSQPatientComponent, DSQPatientComponentState> {
    public render(): JSX.Element {
        let self = this;
        return (
            <div className="dsq-patient-popup">
                <div className="dsn-header">
                    <h4>{cacheStore.GetString("lblSynchronizationDSQ")}</h4>
                </div>
                <div className="dsn-main">
                    <div className="flex-container">
                        <div className="ind-view">
                            <div className="row">
                                <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                                    <label>{cacheStore.GetString("FirstNameLabel")}</label>
                                </div>
                                <div className="col-sm-8 col-md-8 col-lg-8">
                                    {(this.props.patientModel.IndividualResponse.NAM || this.props.patientModel.PatientResponse.SocialNumber || this.props.patientModel.IndividualResponse.NUI) &&
                                        <strong>{this.state.FirstName}</strong>
                                    }
                                    {(!this.props.patientModel.IndividualResponse.NAM && !this.props.patientModel.PatientResponse.SocialNumber && !this.props.patientModel.IndividualResponse.NUI) &&
                                        <input value={this.state.FirstName} onChange={this.onFirstNameChange.bind(this)} type="text" />
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                                    <label>{cacheStore.GetString("LastNameLabel")}</label>
                                </div>
                                <div className="col-sm-8 col-md-8 col-lg-8">
                                    {(this.props.patientModel.IndividualResponse.NAM || this.props.patientModel.PatientResponse.SocialNumber || this.props.patientModel.IndividualResponse.NUI) &&
                                        <strong>{this.state.LastName}</strong>
                                    }
                                    {(!this.props.patientModel.IndividualResponse.NAM && !this.props.patientModel.PatientResponse.SocialNumber && !this.props.patientModel.IndividualResponse.NUI) &&
                                        <input value={this.state.LastName} type="text" onChange={this.onLastNameChange.bind(this)} />
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                                    <label>{cacheStore.GetString("BornDLabel")}</label>
                                </div>
                                <div className="col-sm-8 col-md-8 col-lg-8">
                                    {(this.props.patientModel.IndividualResponse.NAM || this.props.patientModel.PatientResponse.SocialNumber || this.props.patientModel.IndividualResponse.NUI) &&
                                        <strong>{moment(this.state.Born).format("YYYY/MM/DD")}</strong>
                                    }
                                    {(!this.props.patientModel.IndividualResponse.NAM && !this.props.patientModel.PatientResponse.SocialNumber && !this.props.patientModel.IndividualResponse.NUI) && (
                                        <DateSelector
                                            id="dateDsq"
                                            date={this.state.Born}
                                            onChangeCallback={this.onBornChange.bind(this)}
                                            dateFormat="yyyy-MM-dd"
                                            disabled={false}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                                    <label>{cacheStore.GetString("SexAtBirthLabel")}</label>
                                </div>
                                <div className="col-sm-8 col-md-8 col-lg-8">
                                    {(this.props.patientModel.IndividualResponse.NAM || this.props.patientModel.PatientResponse.SocialNumber || this.props.patientModel.IndividualResponse.NUI) &&
                                        <strong>{this.state.Gender}</strong>
                                    }
                                    {(!this.props.patientModel.IndividualResponse.NAM && !this.props.patientModel.PatientResponse.SocialNumber && !this.props.patientModel.IndividualResponse.NUI) && (
                                        <div>
                                            <label style={{ marginRight: "2px" }}>
                                                {cacheStore.GetString("ManLabel")}
                                                <input type="radio" checked={this.state.MaleChecked} onClick={this.onMaleClick.bind(this)} />
                                            </label>
                                            <label style={{ marginRight: "2px" }}>
                                                {cacheStore.GetString("WomanLabel")}
                                                <input type="radio" checked={this.state.FemaleChecked} onClick={this.onFemaleClick.bind(this)} />
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                                    <label>{sessionStore.getDefaultHealthCardLabel()}</label>
                                </div>
                                <div className="col-sm-8 col-md-8 col-lg-8">
                                    {(this.props.patientModel.IndividualResponse.NAM || this.props.patientModel.PatientResponse.SocialNumber || this.props.patientModel.IndividualResponse.NUI) &&
                                        <strong>{this.state.NAM}</strong>
                                    }
                                    {(!this.props.patientModel.IndividualResponse.NAM && !this.props.patientModel.PatientResponse.SocialNumber && !this.props.patientModel.IndividualResponse.NUI) &&
                                        <input value={this.state.NAM} type="text" onChange={this.onNAMChange.bind(this)} />
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                                    <label>{cacheStore.GetString("SINLabel")}</label>
                                </div>
                                <div className="col-sm-8 col-md-8 col-lg-8">
                                    {(this.props.patientModel.IndividualResponse.NAM || this.props.patientModel.PatientResponse.SocialNumber || this.props.patientModel.IndividualResponse.NUI) &&
                                        <strong>{this.state.SIN}</strong>
                                    }
                                    {(!this.props.patientModel.IndividualResponse.NAM && !this.props.patientModel.PatientResponse.SocialNumber && !this.props.patientModel.IndividualResponse.NUI) &&
                                        <input value={this.state.SIN} type="text" onChange={this.onSINChange.bind(this)} />
                                    }

                                </div>
                            </div>
                            <div className="text-right">
                                <button className="btn btn-primary" disabled={this.state.isLoading} onClick={this.onSyncClick.bind(this)}>{cacheStore.GetString("btnSynchroniserDSQ")}</button>
                            </div>
                        </div>
                        <div className="response-view">

                            <div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("FirstNameLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateFirstName}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("LastNameLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateLastName}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{sessionStore.getDefaultHealthCardLabel()} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateNam}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("DateofBirthLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateBirth}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("SexAtBirthLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateGender}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("StreetAddressLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateStreet}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("CityLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateCity}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("StateLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateState}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("ZipPostalCodeLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateZipCode}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("MotherLastNameLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateMotherLastName}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("MotherFirstNameLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateMotherFirstName}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("FatherLastNameLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateFatherLastName}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 col-md-5 col-lg-5 text-right">
                                        <label>{cacheStore.GetString("FatherFirstNameLabel")} - DSQ</label>
                                    </div>
                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <strong>{this.state.CandidateFatherFirstName}</strong>
                                    </div>
                                </div>
                                {!IsNullOrWhiteSpace(self.state.CandidateDeceasedDate) && (
                                    <div className="row">
                                        <div className="col-sm-5 col-md-5 col-lg-5 text-right red">
                                            <label>Date de décès - DSQ</label>
                                        </div>
                                        <div className="col-sm-7 col-md-7 col-lg-7 red">
                                            <strong>{self.state.CandidateDeceasedDate}</strong>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
                <div className="dsn-footer">
                    <div className="row">
                        <div className="col-lg-9 col-md-9 col-sm-9">
                            {this.state.isLoading && <img src={img_loading} alt="loading" />}
                            {self.state.showTruncateMessage && <span className="red" style={{ fontSize: "12px" }}>Le nom et/ou le prénom sont tronqués respectivement à 40 caractères et/ou 25 caractères pour la recherche au DSQ.</span>}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 text-right">
                            <div className="flex-container" style={{ justifyContent: "flex-end" }}>
                                <button className="btn btn-default push-right-5" disabled={this.state.isLoading} onClick={() => this.props.onCloseCallback()}>{cacheStore.GetString("CloseLabel")}</button>
                                <button className="btn btn-primary push-right-5" disabled={this.state.isLoading} onClick={this.onAcceptSyncClick.bind(this)}>Accept Sync</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentWillMount(): void {
        var s = new DSQPatientComponentState();

        let model = this.props.patientModel;

        s.FirstName = model.IndividualResponse.FirstName;
        s.LastName = model.IndividualResponse.LastName;
        s.NAM = model.IndividualResponse.NAM;
        s.NUI = model.IndividualResponse.NUI;
        s.Born = model.IndividualResponse.DateOfBirth;
        s.SIN = model.PatientResponse.SocialNumber;
        s.showTruncateMessage = false;

        if (model.IndividualResponse.GenderLookupId && cacheStore.GetLookupById(model.IndividualResponse.GenderLookupId).LookupCode === "MALE") {
            s.Gender = "M";
            s.MaleChecked = true;
        }
        else if (model.IndividualResponse.GenderLookupId && cacheStore.GetLookupById(model.IndividualResponse.GenderLookupId).LookupCode === "FEMALE") {
            s.Gender = "F";
            s.FemaleChecked = true;
        }

        this.setState(s);

        sessionStore.showGlobalOverlay(true);
    }

    public componentDidMount(): void {
        if (!this.props.patientModel.IndividualResponse.NUI) {
            this.onSyncClick();
        }
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();
    }

    private onLastNameChange(e: ChangeEvent<HTMLInputElement>): void {
        var s = new DSQPatientComponentState();
        s.LastName = e.target.value;
        this.setState(s);
    }

    private onFirstNameChange(e: ChangeEvent<HTMLInputElement>): void {
        var s = new DSQPatientComponentState();
        s.FirstName = e.target.value;
        this.setState(s);
    }

    private onSINChange(e: ChangeEvent<HTMLInputElement>): void {
        var s = new DSQPatientComponentState();
        s.SIN = e.target.value;
        this.setState(s);
    }

    private onNAMChange(e: ChangeEvent<HTMLInputElement>): void {
        var s = new DSQPatientComponentState();
        s.NAM = e.target.value;
        this.setState(s);
    }

    private onBornChange(value: Date): void {
        var s = new DSQPatientComponentState();
        s.Born = value;
        this.setState(s);
    }

    private onMaleClick(): void {
        var s = new DSQPatientComponentState();
        s.MaleChecked = true;
        s.Gender = "M";

        s.FemaleChecked = false;

        this.setState(s);
    }

    private onFemaleClick(): void {
        var s = new DSQPatientComponentState();
        s.FemaleChecked = true;
        s.Gender = "F";

        s.MaleChecked = false;

        this.setState(s);
    }

    private onAcceptSyncClick(): void {
        var self = this;
        var client = new Client();

        var requestData = {
            ContactId: self.props.patientModel.IndividualResponse.Contact_id,
            FirstNameDSQ: self.state.CandidateFirstName,
            LastNameDSQ: self.state.CandidateLastName,
            NUI: self.state.CandidateNUI,
            GenderDSQ: self.state.CandidateGender
        };

        client.Post(apiSettings.buildApiPath(), ServerOperations.Server.DSQ_AcceptSyncPatient, requestData, response => {
            if (response.IsSuccess) {
                patientStore.PatientModels[self.props.patientModel.IndividualResponse.Contact_id].IndividualResponse.NUI = self.state.CandidateNUI;
                patientStore.PatientModels[self.props.patientModel.IndividualResponse.Contact_id].IndividualResponse.FirstNameDSQ = self.state.CandidateFirstName;
                patientStore.PatientModels[self.props.patientModel.IndividualResponse.Contact_id].IndividualResponse.LastNameDSQ = self.state.CandidateLastName;
                patientStore.PatientModels[self.props.patientModel.IndividualResponse.Contact_id].IndividualResponse.GenderDSQ = self.state.CandidateGender;

                patientStore.EmitChangeToListeners();
                labsStore.EmitChangeToListeners();

                self.props.onCloseCallback();
            }
        }, error => {
            console.error(error);
        });
    }

    private onSyncClick(): void {
        var self = this;
        var client = new Client();

        var requestData = {
            Nui: self.state.NUI,
            Nam: self.state.NAM,
            Nas: self.state.SIN,
            FirstName: self.state.FirstName,
            LastName: self.state.LastName,
            GenderCode: self.state.Gender,
            BirthDate: self.state.Born
        };

        var s = new DSQPatientComponentState();
        s.isLoading = true;
        s.CandidateNUI = "";
        s.CandidateNam = "";
        s.CandidateFirstName = "";
        s.CandidateLastName = "";
        s.CandidateBirth = "";
        s.CandidateGender = "";

        s.CandidateStreet = "";
        s.CandidateCity = "";
        s.CandidateState = "";
        s.CandidateZipCode = "";

        s.CandidateMotherLastName = "";
        s.CandidateMotherFirstName = "";
        s.CandidateFatherLastName = "";
        s.CandidateFatherFirstName = "";
        s.CandidateDeceasedDate = "";
        self.setState(s);

        client.PostDSQ(ServerOperations.Server.DSQ_SynchronisePatient, requestData, response => {
            var s = new DSQPatientComponentState();
            s.isLoading = false;

            if (response.Errors.length == 0) {
                s.CandidateNUI = response.CandidateNUI;
                s.CandidateNam = response.CandidateNam;
                s.CandidateFirstName = response.CandidateFirstName;
                s.CandidateLastName = response.CandidateLastName;
                s.CandidateBirth = response.CandidateBirth;
                s.CandidateGender = response.CandidateGender;

                s.CandidateStreet = response.CandidateStreet;
                s.CandidateCity = response.CandidateCity;
                s.CandidateState = response.CandidateState;
                s.CandidateZipCode = response.CandidateZipCode;

                s.CandidateMotherLastName = response.CandidateMotherLastName;
                s.CandidateMotherFirstName = response.CandidateMotherFirstName;
                s.CandidateFatherLastName = response.CandidateFatherLastName;
                s.CandidateFatherFirstName = response.CandidateFatherFirstName;
                s.CandidateDeceasedDate = response.CandidateDeceasedDate;

                // Show a message when first name or last name was truncated in the request
                // This is the data entered for the search, not the result of the search.
                if (self.state.FirstName.length > 25 || self.state.LastName.length > 40) {
                    s.showTruncateMessage = true;
                }
            }
            this.setState(s);
        }, error => {
            var s = new DSQPatientComponentState();
            s.isLoading = false;
            this.setState(s);
            console.error(error);
        });
    }
}

export { DSQPatientComponent };
